import React from 'react';

const NewsHeader = ({
  title,
  onGoBack,
}) => {
  return (
    <div className="single-news-overlay">
      <button
        type="button"
        onClick={onGoBack}
        className="back-button"
      >
        ← Назад
      </button>

      <h1 className="single-news-title">
        {title}
      </h1>
    </div>
  );
};

export default NewsHeader;